import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import Notification from '../../../../components/Notification/Notification';
import history from '../../../../utils/history';
import {basicReferralAccountInfoListRequest} from '../../../../redux/actions/app/basicActions';
import { getUserPageAuth } from '../../../../utils/page-auth';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import useSchemaBasicReferralMain from '../../../../schema/table-schema/useSchemaBasicReferralMain';
import BOTable from '../../../../components/Tables/BOTable';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';

function BasicReferralMain() {
  // -- component const --//
  const title = 'Basic Referral Account';
  const OPTION_KEY = Page.APP_BASIC_REFERRAL;

  const { schema } = useSchemaBasicReferralMain();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(25);

  const [isLoading, setIsLoading] = useState(false);

  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);
  // 검색
  const [accountNo, setAccountNo] = useState(0);
  const [inviteCode, setInviteCode] = useState('');

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      basicReferralAccountInfoListRequest({
        page: page,
        pageLength: Number(pageLength),
        accountNo: accountNo,
        inviteCode: inviteCode,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setTotalCount(data?.totalCount);
          // setTbody(data?.list);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      }),
    );
  }

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleClickRow = (row) => {
      console.log('row: ', row);
    if (row?.accountNo) {
      history.push('/admin/app/basic/referral/invitedUserList', {
        accountNo: row.accountNo,
        inviteCode: row.inviteCode,
        point : row.point,
          createdAt: row.createdAt,
          row: row
      });
    }
  };

    const handleSearchClick = () => {
        if (page === 1) {
            fetchList();
            return;
        }

        setPage(1);
    };

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  // -- render --//
  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <section className="topSection">
        <div className="leftSection">
          <p className="titleText">{title}</p>
        </div>

          <div className="rightSection">
              <button
                  className={"outlineBtn"}
                  onClick={() => {
                      fetchList();
                  }}
              >
                  List 갱신
              </button>
          </div>
      </section>

        <div className="spaceDiv10"/>

        <section className="contentsArea">
            <div className="descDiv">
                <input
                    className=""
                    value={accountNo === 0 ? '' : accountNo}
                    placeholder="유저 ID"
                    onChange={(e) => {
                        setAccountNo(Number(e.target.value));
                    }}
                />

                <input
                    className=""
                    value={inviteCode}
                    placeholder="초대 코드"
                    onChange={(e) => {
                        setInviteCode(e.target.value);
                    }}
                />
                <button className="defaultBtn" onClick={handleSearchClick}>
                    조회
                </button>
            </div>
        </section>




      <div className="spaceDiv10"/>

      <BOTable
        className={'basicReferralMainTable'}
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={handleClickRow}
      />

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  )
}

export default BasicReferralMain;
